import React, { memo, useRef } from 'react'
import ReactPlayer from 'react-player'
import { Icon } from 'antd'
import VideoPlayer from '../../../../../../components/VideoPlayer'

const VideoView = ({
  url,
  poster = '',
  isVisible,
  volume,
  showVolume = true
}) => {
  const playerRef = useRef(null)

  if (!isVisible) {
    return (
      <div
        style={{
          width: '100%',
          height: '250px',
          backgroundColor: '#f0f0f0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#999'
        }}
      >
        <Icon type="play-circle" style={{ fontSize: '48px' }} />
      </div>
    )
  }

  return (
    <div style={{ width: '100%', height: '250px' }}>
      <VideoPlayer
        poster={poster}
        src={url}
        ref={playerRef}
        showVolume={showVolume}
        controlledVolume={volume}
      />
    </div>
  )
}

// CRITICAL: Only re-render VideoPlayer if URL or visibility changes
export default memo(VideoView, (prevProps, nextProps) => {
  return (
    prevProps.url === nextProps.url &&
    prevProps.isVisible === nextProps.isVisible &&
    prevProps.volume === nextProps.volume
  )
})
